/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {GET_REDLINE_DATA} from "./types";
import { put, takeEvery, call, cancelled, select } from "redux-saga/effects";
import {
  getRedlineDataErrorAction,
  getRedlineDataSuccessAction,
  selectRedlineDataState,
} from "./slice";
import {loginRequest, requestIdToken} from "../../../auth/authConfig";
import toast from "react-hot-toast";
import {
  fetchDatasetDataEndpointFullURL
} from "../../../containers/pages/CoverageRequirements/ItemDetails/Tabs/CoverageRequirementsTab/RightPanelComponents/constants";


function* getRedlineDataSaga2(request: any): any {
  const payload = request.payload
  const {instance, accounts, body} = payload
  let idTok: string = ''
  const abortController = new AbortController();
  try {
    idTok = yield call(requestIdToken, instance, accounts);
    const url = fetchDatasetDataEndpointFullURL
    // store unix timestamp in redux
    const timestamp = new Date().getTime();
    const response: any = yield fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${idTok}`
        },
      body: JSON.stringify(body),
      signal: abortController.signal
    })
    if (response?.status === 401){
        instance?.loginRedirect(loginRequest).catch((e: any) => {
          console.log(e);
        });
      }
    const redlineData = yield select(selectRedlineDataState)
    if (redlineData.recentPollTimestamp > timestamp) {
      // console.log('Redline data is stale, aborting fetch.')
      abortController.abort()
      // yield cancelled()
      return
    }
    const value = yield response.json()
    yield put(getRedlineDataSuccessAction(value));
  } catch (error: any) {
    toast.error("Error fetching redline data.");
    yield put(getRedlineDataErrorAction("Error fetching redline data."));
  } finally {
    if (yield cancelled()) {
      abortController.abort();
    }
  }
}

export function* watchPollGetRedlineData() {
  yield takeEvery(GET_REDLINE_DATA, getRedlineDataSaga2);
}